import { createSlice } from "@reduxjs/toolkit";
import {
  AddCmsAction,
  DeleteCmsAction,
  GetAllCmsAction,
  UpdateCmsAction,
} from "store/middlewares/cms";

export const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    cmsLoading: true,
    cms: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllCmsAction.pending, (state) => {
        // state.cmsLoading = true;
        // state.cms = [];
        state.cms =
          state.cms?.length > 0 ? state.cms : null;
      })
      .addCase(GetAllCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = action.payload.response;
      })
      .addCase(GetAllCmsAction.rejected, (state) => {
        state.cmsLoading = false;
        state.cms = [];
      })

      //Update
      .addCase(UpdateCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = action.payload.response;
      })

      // Delete Reject Reason
      .addCase(DeleteCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = state.cms?.filter((item) => item.id !== action.payload.id);;
      })
      
      //Add Reject Reason
      .addCase(AddCmsAction.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cms = [action.payload.response, ... state.cms];
      });
  },
});

export default cmsSlice.reducer;
